export class DailyEngagedUserUsage {
  dateReference!: string;
  dailyEngagedUsers!: number;
  activeMessage!: number;

  constructor(raw: { dateReference: string; metricConsumption: { metricId: string; total: number }[] }) {
    this.dateReference = raw.dateReference;
    this.dailyEngagedUsers = raw.metricConsumption.find(mc => mc.metricId === 'DailyEngagedUser')?.total ?? 0;
    this.activeMessage = raw.metricConsumption.find(mc => mc.metricId === 'ActiveMessage')?.total ?? 0;
  }
}